import { getBaseURL } from '../../../GlobalComponents/URLs'
export const sendLog = (message) => {
    let log = { message: message, application: 'FMS' }
    let url = getBaseURL() + 'webapi/form/awclog'
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        //credentials: 'include',
        body: JSON.stringify(log),
    })
}
